module.exports = __webpack_public_path__ + "img/guardian_buff_bugles_blessing.7d2aeaed.png";